import { memo } from 'react';
import { Box, Circle, Flex, ListItem, Stack, Text, UnorderedList } from '@chakra-ui/react';

import { DEFAULT_BORDER } from 'constants/global';

const CardList = ({ list, cardIndex }) => (
  <>
    {cardIndex !== 2 ? (
      <UnorderedList ml={{ mobile: '26px', laptop: '34px' }}>
        {list.map(text => (
          <ListItem key={text} textStyle="h2">
            {text}
          </ListItem>
        ))}
      </UnorderedList>
    ) : (
      <Flex direction={{ mobile: 'column', tablet: 'row' }} w="full" align="start">
        {list.map((step, i) => (
          <Stack
            key={step}
            direction={{ mobile: 'column', tablet: 'row' }}
            gap="0"
            flex={{ tablet: '1 1 0' }}
            pos="relative"
          >
            <Stack
              direction={{ mobile: 'row', tablet: 'column' }}
              align={{ mobile: 'center', tablet: 'start' }}
              gap={{ mobile: '8px', tablet: '12px', laptop: '16px' }}
            >
              <Circle
                flexShrink="0"
                size={{ mobile: '32px', laptop: '40px' }}
                bgColor="bg.white"
                border={DEFAULT_BORDER}
                borderColor="line.grayLight"
                position="relative"
                zIndex="1"
              >
                <Text
                  textStyle="h4"
                  fontSize={{ mobile: '12px', laptop: '16px' }}
                  fontWeight={{ mobile: '500', laptop: '400' }}
                >
                  {String(i + 1).padStart(2, '0')}
                </Text>
              </Circle>

              <Text textStyle="h2" fontWeight="500" pr={{ tablet: '16px', laptop: '47px' }}>
                {step}
              </Text>
            </Stack>

            {i < list.length - 1 && (
              <Box
                position={{ mobile: 'static', tablet: 'absolute' }}
                top={{ tablet: '16px', laptop: '20px' }}
                left={{ tablet: '32px', laptop: '40px' }}
                right={{ tablet: 0 }}
                ml={{ mobile: '16px', tablet: 'unset' }}
                h={{ mobile: '16px', tablet: 'unset' }}
                borderLeftWidth={{ mobile: '1.5px', tablet: 'none' }}
                borderBottomWidth={{ tablet: '1.5px' }}
                opacity=".13"
                sx={{
                  '@media (max-width: 656px)': {
                    borderImage:
                      'repeating-linear-gradient(180deg, #575C66 0, #575C66 5px, transparent 4px, transparent 10px) 1',
                  },
                  '@media (min-width: 655px)': {
                    borderImage:
                      'repeating-linear-gradient(90deg, #575C66 0, #575C66 13px, transparent 13px, transparent 26px) 1',
                  },
                }}
              />
            )}
          </Stack>
        ))}
      </Flex>
    )}
  </>
);

export default memo(CardList);
